const miqfucsia = Object.freeze({
    base:         '#f50886',
    lighten5:     '#F8F3F5',
    lighten4:     '#fae9ee',
    lighten3:     '#ffb4cf',
    lighten2:     '#f688af',
    lighten1:     '#ff4898',
    darken1:      '#e90083',
    darken2:      '#d9007f',
    darken3:      '#ca0079',
    darken4:      '#9d216c',
    accent1:      '#ffbbd0',
    accent2:      '#ff83b4',
    accent3:      '#ff39a8',
    accent4:      '#ff00a9'
  });
const miqlightslategray = Object.freeze({
    base:         '#778da4',
    lighten5:     '#e5e9ee',
    lighten4:     '#d9dfe5',
    lighten3:     '#c0cad5',
    lighten2:     '#a8b6c5',
    lighten1:     '#8fa1b4',
    darken1:      '#5f768e',
    darken2:      '#4d5f73',
    darken3:      '#3a4857',
    darken4:      '#28313c',
    accent1:      '#868E96',
    accent2:      '#164E6F',
    accent3:      '#00255B',
    accent4:      '#000C3D'
  });
const miqslategray = Object.freeze({
    base:         '#868e96',
    lighten5:     '#EFEFEF',
    lighten4:     '#D7D7D7',
    lighten3:     '#BBBCBD',
    lighten2:     '#9DA2A7',
    lighten1:     '#868E96',
    darken1:      '#636C75',
    darken2:      '#52585E',
    darken3:      '#424649',
    darken4:      '#303132',
    accent1:      '#868E96',
    accent2:      '#164E6F',
    accent3:      '#00255B',
    accent4:      '#000C3D'
  });
const miqspaceblue = Object.freeze({
    base:         '#415a99',
    lighten5:     '#E8EBF2',
    lighten4:     '#C4CCE0',          
    lighten3:     '#9FACCB',
    lighten2:     '#7A8BB5',
    lighten1:     '#5D72A6',
    darken1:      '#3B5290',
    darken2:      '#324884',
    darken3:      '#2B3F77',
    darken4:      '#212E60', //base offset
    accent1:      '#79B0EC',
    accent2:      '#4186D4',
    accent3:      '#4270B6',
    accent4:      '#415A99'
  });  
const miqfiercerose = Object.freeze({
    base:         '#ff586b',
    lighten5:     '#FFE9EE',
    lighten4:     '#ffe1e8',          
    lighten3:     '#fdb9c4',
    lighten2:     '#ff869e',
    lighten1:     '#ff6a84',
    darken1:      '#ee5167',
    darken2:      '#db4d66',
    darken3:      '#c64462',
    darken4:      '#a23a5c',
    accent1:      '#ffadbc',
    accent2:      '#ff8392',
    accent3:      '#ff555f',
    accent4:      '#de486a'
  });  
const miqturquoise = Object.freeze({
    base:         '#1CBCD8',
    lighten5:     '#E8F9FC',
    lighten4:     '#D2F3F9',          
    lighten3:     '#A5E7F3',
    lighten2:     '#78DCED',
    lighten1:     '#4AD0E8',
    darken1:      '#179DB5',
    darken2:      '#127687',
    darken3:      '#0C4E5A',
    darken4:      '#06272D',
    accent1:      '#85FFFF',
    accent2:      '#21FFFF',
    accent3:      '#1BE8FF',
    accent4:      '#1CBCD8'
  });  
const miqgreen = Object.freeze({
    base:         '#0CC27E',
    lighten5:     '#E7FEF5',
    lighten4:     '#d5f7e5',          
    lighten3:     '#a8e6c6',
    lighten2:     '#77d8a9',
    lighten1:     '#51cd93',
    darken1:      '#03b374',
    darken2:      '#009f65',
    darken3:      '#008d58',
    darken4:      '#006e44',
    accent1:      '#ceffef',
    accent2:      '#5bffdb',
    accent3:      '#3cf4bc',
    accent4:      '#29d698'
  });  
const miqtangerine = Object.freeze({
    base:         '#FF8D60',
    lighten5:     '#ffffff',
    lighten4:     '#FFEDE5',          
    lighten3:     '#f0d7ce',
    lighten2:     '#f9baa2',
    lighten1:     '#fca07e',
    darken1:      '#f4865b',
    darken2:      '#e78058',
    darken3:      '#d87852',
    darken4:      '#c16b4a',
    accent1:      '#f3cbbd',
    accent2:      '#fca07b',
    accent3:      '#ff7c4c',
    accent4:      '#de6a43'
  });
const miqlightblue = Object.freeze({
    base:         '#6BA1F5',
    lighten5:     '#EAF3FB',
    lighten4:     '#CDE1F6',
    lighten3:     '#ADD0F5',
    lighten2:     '#8DBEF5',
    lighten1:     '#78AFF6',
    darken1:      '#6593E6',
    darken2:      '#5C80D3',
    darken3:      '#556FC0',
    darken4:      '#4851A1',
    accent1:      '#CDE1F6',
    accent2:      '#C4DCFD',
    accent3:      '#C1D5FF',
    accent4:      '#C8CCFF'
  });
const miqdesaturatedblue = Object.freeze({
    base:         '#6686A6',
    lighten5:     '#E6F1FF',
    lighten4:     '#C9DCF0',
    lighten3:     '#AFC4DB',
    lighten2:     '#92ABC7',
    lighten1:     '#7C98B6',
    darken1:      '#587794',
    darken2:      '#47627D',
    darken3:      '#394F66',
    darken4:      '#263A4E',
    accent1:      '#7C98B6',
    accent2:      '#005D99',
    accent3:      '#003A84',
    accent4:      '#00226F'
  });  
const miqblackblue = Object.freeze({
    base:         '#202332',
    lighten5:     '#6a73a0',
    lighten4:     '#606996',
    lighten3:     '#50577D',
    lighten2:     '#404664',
    lighten1:     '#30344B',
    darken1:      '#0E0F16',
    darken2:      '#000000',
    darken3:      '#000000',
    darken4:      '#000000',
    accent1:      '#6D93EB',
    accent2:      '#005BBD',
    accent3:      '#003883',
    accent4:      '#202332'
  });  
  const miqconcrete = Object.freeze({
    base:         '#989EA0',
    lighten5:     '#FFFFFF',
    lighten4:     '#F8F8F8',
    lighten3:     '#ECEFF0',
    lighten2:     '#D6D9DA',
    lighten1:     '#B8BBBC',
    darken1:      '#5D696F',
    darken2:      '#394145',
    darken3:      '#1e2224',
    darken4:      '#090b0b',
    accent1:      '#618B98',
    accent2:      '#51747F',
    accent3:      '#005669',
    accent4:      '#00374A'
  });  
//default from Material design (vuetify) vuetify/lib/util/colors
/* Copied file and include it in the vuetify.js for overriding custom colors */
const red = Object.freeze({
    base:         '#f44336',
    lighten5:     '#ffebee',
    lighten4:     '#ffcdd2',
    lighten3:     '#ef9a9a',
    lighten2:     '#e57373',
    lighten1:     '#ef5350',
    darken1:      '#e53935',
    darken2:      '#d32f2f',
    darken3:      '#c62828',
    darken4:      '#b71c1c',
    accent1:      '#ff8a80',
    accent2:      '#ff5252',
    accent3:      '#ff1744',
    accent4:      '#d50000'
  });  
  const pink = Object.freeze({
    base:         '#e91e63',
    lighten5:     '#fce4ec',
    lighten4:     '#f8bbd0',
    lighten3:     '#f48fb1',
    lighten2:     '#f06292',
    lighten1:     '#ec407a',
    darken1:      '#d81b60',
    darken2:      '#c2185b',
    darken3:      '#ad1457',
    darken4:      '#880e4f',
    accent1:      '#ff80ab',
    accent2:      '#ff4081',
    accent3:      '#f50057',
    accent4:      '#c51162'
  });
  const purple = Object.freeze({
    base: '#9c27b0',
    lighten5: '#f3e5f5',
    lighten4: '#e1bee7',
    lighten3: '#ce93d8',
    lighten2: '#ba68c8',
    lighten1: '#ab47bc',
    darken1: '#8e24aa',
    darken2: '#7b1fa2',
    darken3: '#6a1b9a',
    darken4: '#4a148c',
    accent1: '#ea80fc',
    accent2: '#e040fb',
    accent3: '#d500f9',
    accent4: '#aa00ff'
  });
  const deepPurple = Object.freeze({
    base: '#673ab7',
    lighten5: '#ede7f6',
    lighten4: '#d1c4e9',
    lighten3: '#b39ddb',
    lighten2: '#9575cd',
    lighten1: '#7e57c2',
    darken1: '#5e35b1',
    darken2: '#512da8',
    darken3: '#4527a0',
    darken4: '#311b92',
    accent1: '#b388ff',
    accent2: '#7c4dff',
    accent3: '#651fff',
    accent4: '#6200ea'
  });
  const indigo = Object.freeze({
    base: '#3f51b5',
    lighten5: '#e8eaf6',
    lighten4: '#c5cae9',
    lighten3: '#9fa8da',
    lighten2: '#7986cb',
    lighten1: '#5c6bc0',
    darken1: '#3949ab',
    darken2: '#303f9f',
    darken3: '#283593',
    darken4: '#1a237e',
    accent1: '#8c9eff',
    accent2: '#536dfe',
    accent3: '#3d5afe',
    accent4: '#304ffe'
  });
  const blue = Object.freeze({
    base: '#2196f3',
    lighten5: '#e3f2fd',
    lighten4: '#bbdefb',
    lighten3: '#90caf9',
    lighten2: '#64b5f6',
    lighten1: '#42a5f5',
    darken1: '#1e88e5',
    darken2: '#1976d2',
    darken3: '#1565c0',
    darken4: '#0d47a1',
    accent1: '#82b1ff',
    accent2: '#448aff',
    accent3: '#2979ff',
    accent4: '#2962ff'
  });
  const lightBlue = Object.freeze({
    base: '#03a9f4',
    lighten5: '#e1f5fe',
    lighten4: '#b3e5fc',
    lighten3: '#81d4fa',
    lighten2: '#4fc3f7',
    lighten1: '#29b6f6',
    darken1: '#039be5',
    darken2: '#0288d1',
    darken3: '#0277bd',
    darken4: '#01579b',
    accent1: '#80d8ff',
    accent2: '#40c4ff',
    accent3: '#00b0ff',
    accent4: '#0091ea'
  });
  const cyan = Object.freeze({
    base: '#00bcd4',
    lighten5: '#e0f7fa',
    lighten4: '#b2ebf2',
    lighten3: '#80deea',
    lighten2: '#4dd0e1',
    lighten1: '#26c6da',
    darken1: '#00acc1',
    darken2: '#0097a7',
    darken3: '#00838f',
    darken4: '#006064',
    accent1: '#84ffff',
    accent2: '#18ffff',
    accent3: '#00e5ff',
    accent4: '#00b8d4'
  });
  const teal = Object.freeze({
    base: '#009688',
    lighten5: '#e0f2f1',
    lighten4: '#b2dfdb',
    lighten3: '#80cbc4',
    lighten2: '#4db6ac',
    lighten1: '#26a69a',
    darken1: '#00897b',
    darken2: '#00796b',
    darken3: '#00695c',
    darken4: '#004d40',
    accent1: '#a7ffeb',
    accent2: '#64ffda',
    accent3: '#1de9b6',
    accent4: '#00bfa5'
  });
  const green = Object.freeze({
    base: '#4caf50',
    lighten5: '#e8f5e9',
    lighten4: '#c8e6c9',
    lighten3: '#a5d6a7',
    lighten2: '#81c784',
    lighten1: '#66bb6a',
    darken1: '#43a047',
    darken2: '#388e3c',
    darken3: '#2e7d32',
    darken4: '#1b5e20',
    accent1: '#b9f6ca',
    accent2: '#69f0ae',
    accent3: '#00e676',
    accent4: '#00c853'
  });
  const lightGreen = Object.freeze({
    base: '#8bc34a',
    lighten5: '#f1f8e9',
    lighten4: '#dcedc8',
    lighten3: '#c5e1a5',
    lighten2: '#aed581',
    lighten1: '#9ccc65',
    darken1: '#7cb342',
    darken2: '#689f38',
    darken3: '#558b2f',
    darken4: '#33691e',
    accent1: '#ccff90',
    accent2: '#b2ff59',
    accent3: '#76ff03',
    accent4: '#64dd17'
  });
  const lime = Object.freeze({
    base: '#cddc39',
    lighten5: '#f9fbe7',
    lighten4: '#f0f4c3',
    lighten3: '#e6ee9c',
    lighten2: '#dce775',
    lighten1: '#d4e157',
    darken1: '#c0ca33',
    darken2: '#afb42b',
    darken3: '#9e9d24',
    darken4: '#827717',
    accent1: '#f4ff81',
    accent2: '#eeff41',
    accent3: '#c6ff00',
    accent4: '#aeea00'
  });
  const yellow = Object.freeze({
    base: '#ffeb3b',
    lighten5: '#fffde7',
    lighten4: '#fff9c4',
    lighten3: '#fff59d',
    lighten2: '#fff176',
    lighten1: '#ffee58',
    darken1: '#fdd835',
    darken2: '#fbc02d',
    darken3: '#f9a825',
    darken4: '#f57f17',
    accent1: '#ffff8d',
    accent2: '#ffff00',
    accent3: '#ffea00',
    accent4: '#ffd600'
  });
  const amber = Object.freeze({
    base: '#ffc107',
    lighten5: '#fff8e1',
    lighten4: '#ffecb3',
    lighten3: '#ffe082',
    lighten2: '#ffd54f',
    lighten1: '#ffca28',
    darken1: '#ffb300',
    darken2: '#ffa000',
    darken3: '#ff8f00',
    darken4: '#ff6f00',
    accent1: '#ffe57f',
    accent2: '#ffd740',
    accent3: '#ffc400',
    accent4: '#ffab00'
  });
  const orange = Object.freeze({
    base: '#ff9800',
    lighten5: '#fff3e0',
    lighten4: '#ffe0b2',
    lighten3: '#ffcc80',
    lighten2: '#ffb74d',
    lighten1: '#ffa726',
    darken1: '#fb8c00',
    darken2: '#f57c00',
    darken3: '#ef6c00',
    darken4: '#e65100',
    accent1: '#ffd180',
    accent2: '#ffab40',
    accent3: '#ff9100',
    accent4: '#ff6d00'
  });
  const deepOrange = Object.freeze({
    base: '#ff5722',
    lighten5: '#fbe9e7',
    lighten4: '#ffccbc',
    lighten3: '#ffab91',
    lighten2: '#ff8a65',
    lighten1: '#ff7043',
    darken1: '#f4511e',
    darken2: '#e64a19',
    darken3: '#d84315',
    darken4: '#bf360c',
    accent1: '#ff9e80',
    accent2: '#ff6e40',
    accent3: '#ff3d00',
    accent4: '#dd2c00'
  });
  const brown = Object.freeze({
    base: '#795548',
    lighten5: '#efebe9',
    lighten4: '#d7ccc8',
    lighten3: '#bcaaa4',
    lighten2: '#a1887f',
    lighten1: '#8d6e63',
    darken1: '#6d4c41',
    darken2: '#5d4037',
    darken3: '#4e342e',
    darken4: '#3e2723'
  });
  const blueGrey = Object.freeze({
    base: '#607d8b',
    lighten5: '#eceff1',
    lighten4: '#cfd8dc',
    lighten3: '#b0bec5',
    lighten2: '#90a4ae',
    lighten1: '#78909c',
    darken1: '#546e7a',
    darken2: '#455a64',
    darken3: '#37474f',
    darken4: '#263238'
  });
  const grey = Object.freeze({
    base: '#9e9e9e',
    lighten5: '#fafafa',
    lighten4: '#f5f5f5',
    lighten3: '#eeeeee',
    lighten2: '#e0e0e0',
    lighten1: '#bdbdbd',
    darken1: '#757575',
    darken2: '#616161',
    darken3: '#424242',
    darken4: '#212121'
  });
  const shades = Object.freeze({
    black: '#000000',
    white: '#ffffff',
    transparent: 'transparent'
  });
  export default Object.freeze({
    miqfucsia,
    miqslategray,
    miqlightslategray,
    miqspaceblue,
    miqfiercerose,
    miqturquoise,
    miqgreen,
    miqtangerine,
    miqlightblue,
    miqdesaturatedblue,
    miqblackblue,
    miqconcrete,
    red,
    pink,
    purple,
    deepPurple,
    indigo,
    blue,
    lightBlue,
    cyan,
    teal,
    green,
    lightGreen,
    lime,
    yellow,
    amber,
    orange,
    deepOrange,
    brown,
    blueGrey,
    grey,
    shades
  });
  //# sourceMappingURL=colors.js.map